import { FlowName } from '@fiverr-private/listing_types';

export const isRolesListings = (flowName: FlowName): boolean => flowName === 'roleSearchFlow';
export const isGigProfessionListings = (flowName: FlowName): boolean => flowName === 'gigProfessionSearchFlow';
